<template>
  <form
    :class="{ 'form--error': errorMessage.length > 0 }"
    @submit.prevent="validateForm">
    <div
      v-for="(trackForm, trackIndex) in trackForms"
      :key="trackIndex">
      <div class="form-title">
        {{ trackIndex + 1 }}. {{ tracks[trackIndex].titles[0].title }}
      </div>
      <div
        v-for="(field, index) in trackForm"
        :key="index"
        class="form-group">
        <div
          v-if="trackForm && trackForm[index]">
          <div class="row">
            <div class="form-group small-input">
              <div
                v-if="showLabel(index)"
                class="form-label">
                <label
                  class="control-label"
                  for="rate">
                  分配率
                </label>
              </div>
              <div class="form-item input-w-icon-right">
                <input
                  id="rate"
                  v-model.number="field.rate"
                  class="form-control percentage"
                  type="text"
                  min="0"
                  name="rate"
                  :disabled="field.isDisabled"
                  @keydown="validateRateInput($event, field, index, trackIndex)"
                  @input="validateRateInput($event,field,index, trackIndex)">
                <span class="icon-input-right">
                  <svg
                    class="icon-input-percentage"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 490.615 490.615"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    enable-background="new 0 0 490.615 490.615">
                    <g>
                      <path
                        d="M0,475.876L475.525,0.351l14.425,14.425L14.425,490.301L0,
                          475.876z" />
                      <path
                        d="m106.915,212.908c58.7,
                          0 106.3-47.6 106.3-106.3s-47.6-106.3-106.3-106.3-106.3,47.6-106.3,
                          106.3 47.6,106.3 106.3,106.3zm0-192.5c47.6,1.42109e-14 86.2,
                          38.6 86.2,86.2s-38.6,86.2-86.2,
                          86.2-86.2-38.6-86.2-86.2 38.6-86.2 86.2-86.2z" />
                      <path
                        d="m384.315,277.708c-58.7,
                          0-106.3,47.6-106.3,106.3s47.6,106.3 106.3,
                          106.3 106.3-47.6 106.3-106.3-47.6-106.3-106.3-106.3zm0,
                          192.5c-47.6,0-86.2-38.6-86.2-86.2s38.6-86.2 86.2-86.2 86.2,
                          38.6 86.2,86.2-38.6,86.2-86.2,86.2z" />
                    </g>
                  </svg>
                </span>
                <p
                  v-if="errors[trackIndex][index].rate"
                  class="error-text">
                  {{ errors[trackIndex][index].rate }}
                </p>
              </div>
            </div>
            <div class="form-group form-group-large large-input">
              <div
                v-if="showLabel(index)"
                class="form-label"
                style="width: auto">
                <label
                  class="control-label"
                  for="email">
                  メンバー
                </label>
              </div>
              <div class="form-item">
                <span class="icon-input-left">
                  <svg
                    id="Layer_1"
                    class="icon-input-mail"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 490 490"
                    style="enable-background:new 0 0 490 490;"
                    xml:space="preserve">
                    <g>
                      <path
                        d="M480,85H10C4.478,85,0,89.478,0,95v300c0,
                           5.522,4.478,10,10,10h470c5.522,0,10-4.478,10-10V95
                           C490,89.478,485.522,85,480,85z M443.676,105L245,223.36L46.324,
                           105H443.676z M470,385H20V112.597l150.807,89.842l-107.014,84.72
                           l12.414,15.682l112.986-89.447l50.688,30.197C241.459,
                           244.53,243.229,245,245,245s3.541-0.47,5.118-1.409l50.688-30.197
                           l112.986,89.447l12.414-15.682L319.193,202.44L470,112.597V385z" />
                    </g>
                  </svg>
                </span>
                <input
                  id="email"
                  ref="email"
                  v-model="field.email"
                  :disabled="field.isDisabled ? field.isDisabled : index === 0"
                  class="form-control pad-left-20"
                  type="email"
                  name="email">
                <p
                  v-if="errors[trackIndex][index].email"
                  class="error-text">
                  {{ errors[trackIndex][index].email }}
                </p>
              </div>
            </div>
            <div class="form-group form-group-large large-input">
              <div
                v-if="showLabel(index)"
                class="form-label">
                <label
                  class="control-label"
                  for="memo">
                  メモ
                </label>
              </div>
              <div class="form-item">
                <input
                  id="memo"
                  ref="memo"
                  v-model="field.memo"
                  class="form-control"
                  type="text"
                  :disabled="field.isDisabled"
                  placeholder="名前など"
                  name="memo">
              </div>
            </div>
            <div class="form-group ml-10">
              <div
                v-if="showLabel(index)"
                class="form-label">
                <label
                  class="control-label"
                  for="role">
                  役割
                </label>
              </div>
              <div class="form-item custom-select">
                <select
                  :id="'role' + trackIndex + index"
                  v-model="field.role"
                  required
                  :disabled="field.isDisabled"
                  name="role">
                  <option
                    v-for="(option,index1) in roles"
                    :key="option.role + trackIndex+index1"
                    :value="option">
                    {{ option.role }}
                  </option>
                </select>
                <p
                  v-if="errors[trackIndex][index].role"
                  class="error-text">
                  {{ errors[trackIndex][index].role }}
                </p>
              </div>
            </div>
            <div class="small-minus">
              <div
                class="del-div"
                @click.prevent="deleteField(trackIndex, index)">
                <div
                  v-if="trackForm.length > 1 && index !== 0 && !field.isDisabled"
                  class="minus-box-style">
                  <span
                    class="mdi mdi-minus-box"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="large-minus">
            <div
              class="del-div"
              @click.prevent="deleteField(trackIndex, index)">
              <div
                v-if="trackForm.length > 1 && index !== 0 && !field.isDisabled"
                class="minus-box-style">
                <span
                  class="mdi mdi-minus-box">
                </span>
                削除
              </div>
            </div>
          </div>
        </div>
        <hr class="line">
      </div>
      <div class="form-btn-area-top">
        <div class="total-text">
          合計：{{ percentage[trackIndex] }} %
          <div>
            <p
              v-if="errorMessage[trackIndex]"
              class="error-text">
              {{ errorMessage[trackIndex] }}
            </p>
          </div>
        </div>
        <button
          v-if="
            (
              (
                !(percentage[trackIndex] >= 100) ||
                (trackForm.length === 1 && percentage[trackIndex] >= 100)
              ) &&
              releaseType === 'single'
              ||
              (
                percentage[trackIndex] !== 100 &&
                !(percentage[trackIndex] >= 100)
              ) &&
                releaseType === 'album'
            )"
          class="c-btn c-btn--back c-btn-mini"
          type="button"
          @click.prevent="addField(trackIndex)">
          <span class="c-btn__icon-add icon-btn">
            <span style="width: 78%"></span>
          </span>
          ゲストを追加
        </button>
      </div>
    </div>
    <revenue-share-form-bottom-area
      :confirm-button="'内容を確認する'"
      :back-button="'リリース選択へ戻る'"
      @submitForm="validateForm"
      @viewForm="stepBack" />
  </form>
</template>

<script>
import RevenueShareFormBottomArea from './RevenueShareFormBottomArea'

export default {
  name: 'RevenueSharingForm',
  components: {
    RevenueShareFormBottomArea,
  },
  props: {
    formFieldsData: {
      type: Array,
      required: true,
    },
    errorsData: {
      type: Array,
      required: true,
    },
    tracks: {
      type: Array,
      required: true,
    },
    releaseType: {
      type: String,
      required: true,
    },
    percentageError: {
      type: Array,
      required: true,
    },
    percentageData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      errors: this.errorsData,
      errorMessage: this.percentageError,
      roles: [],
      trackForms: this.formFieldsData,
      showForm: true,
      percentage: this.percentageData,
      productDiscTrackId: '',
      disableSubmitButton: false,
      productDiscTracksInRevenueShare: [],
      productId: '',
      isMobileScreen: false,
    }
  },
  watch: {
    trackForms: {
      deep: true,
      handler() {
        this.trackForms.forEach((item1, trackIndex) => {
          let percentage = 0.0
          item1.forEach((item, index) => {
            if (item.rate < 100 || item.rate.toString()) {
              percentage += item.rate
            }
            if (item.email && this.validateEmail(item.email)
              && !this.isDuplicateEmail(trackIndex, index, item)) {
              this.errors[trackIndex][index].email = ''
            }
            if (item.role.id) {
              this.errors[trackIndex][index].role = ''
            }
          })
          this.percentage[trackIndex] = percentage
          if (percentage === 100) this.errorMessage[[trackIndex]] = ''
        })
      },
    },
  },
  mounted() {
    const { id } = this.$route.params
    const { productId } = JSON.parse(window.sessionStorage.getItem('split')) || {}
    // check whether current processing productId and id of query params match or not.
    if (!productId || parseInt(productId, 10) !== parseInt(id, 10)) {
      this.$router.push({ name: 'index' })
      return
    }
    this.productId = id
    this.fetchCollaboratorRoles()
    if (window.screen.width < 900) this.isMobileScreen = true
  },
  methods: {
    async fetchCollaboratorRoles() {
      const { data } = await window.axios.get('/api/client/collaboratorRoles')
      this.roles = data.data
    },

    addField(trackIndex) {
      if (this.trackForms[trackIndex].length < 99) {
        this.errors[trackIndex].push({
          rate: '',
          email: '',
          role: '',
        })
        this.trackForms[trackIndex].push({
          rate: '',
          email: '',
          memo: '',
          role: '',
          owner: 0,
          product_disc_track_id: this.trackForms[trackIndex][0].product_disc_track_id,
          product_id: this.productId,
        })
      }
    },
    deleteField(trackIndex, index) {
      this.trackForms[trackIndex].splice(index, 1)
      this.errors[trackIndex].splice(index, 1)
    },
    validateForm() {
      let valid = true
      this.errorMessage = []
      let ownerHasOneNoneZeroRate = false
      let totalOwnerPercentage = 0
      this.trackForms.forEach((formField, trackIndex) => {
        // Reset error messages
        formField.forEach((field, index) => {
          this.errors[trackIndex][index] = {
            rate: '',
            email: '',
            role: '',
          }

          if (field.email === '') {
            valid = false
            this.errors[trackIndex][index].email = '必須項目です'
          } else if (!this.validateEmail(field.email)) {
            valid = false
            this.errors[trackIndex][index].email = 'メールアドレスの形式で入力してください'
          } else if (this.isDuplicateEmail(trackIndex, index, field)) {
            valid = false
            this.errors[trackIndex][index].email = '同じメールアドレスは設定できません'
          }

          if (!field.role.id) {
            valid = false
            this.errors[trackIndex][index].role = '役割を選択してください'
          }
          if (field.rate === '' || (field.rate < 0 && this.releaseType === 'album') || (field.rate <= 0 && this.releaseType === 'single')) {
            valid = false
            this.errors[trackIndex][index].rate = '必須項目です'
            if (field.rate < 0) {
              this.errors[trackIndex][index].rate = '収益分配％は負号（-ve）に設定できません。'
            }
          }
          // full 100% is not valid in case of single ( for Single Case)
          if (field.rate === 100 && this.releaseType === 'single') {
            // add collaborator error should be displayed in owner case only
            if (index === 0) {
              valid = false
              this.errors[trackIndex][index].rate = 'ゲストの追加は必須です。'
            }
          }
          // tracking rate of owner to check at least one rate is more than 0% (for Album Case)
          if (this.releaseType === 'album' && index === 0) {
            if (field.rate > 0) {
              ownerHasOneNoneZeroRate = true
            }
            // calculating total percentage of owner (For Album case)
            totalOwnerPercentage += field.rate
          }
        })
      })
      // checking if all owner's rate is 0%
      if (!ownerHasOneNoneZeroRate && this.releaseType === 'album') {
        valid = false
        this.trackForms.forEach((item, index) => {
          this.errorMessage[index] = 'オーナーの分配率を1曲上以に設定してください。'
        })
      }
      // checking if 100% rate is assigned to owner for all song
      if (totalOwnerPercentage / this.trackForms.length === 100 && this.releaseType === 'album') {
        valid = false
        this.trackForms.forEach((item, index) => {
          this.errorMessage[index] = '1曲上以にゲストを設定してください'
        })
      }
      this.trackForms.forEach((form, trackIndex) => {
        // Calculate total percentage
        let totalPercentage = 0
        form.forEach((field) => {
          totalPercentage += field.rate
        })
        this.percentage[trackIndex] = totalPercentage
        if (this.percentage[trackIndex] !== 100) {
          valid = false
          this.errorMessage[trackIndex] = '合計が100%になるように設定してください。'
        } else if (valid) {
          this.errorMessage[trackIndex] = ''
          this.currentStep = 3
          this.showForm = false
        }
      })
      this.percentage.forEach((percent, i) => {
        if (percent !== 100) {
          this.errorMessage[i] = '合計が100%になるように設定してください。'
          valid = false
          this.showForm = true
        }
      })
      if (valid) this.$emit('viewForm', false)
      this.errors = [...this.errors]
    },
    isDuplicateEmail(trackIndex, index, field) {
      const formField = this.trackForms[trackIndex].filter(f => f !== field)
      let isDuplicate = false
      formField.forEach((field1) => {
        if (field.email === field1.email) {
          this.errors[trackIndex][index].email = '同じメールアドレスは設定できません'
          if (index === 0) this.errors[trackIndex][index].email = ''
          isDuplicate = true
        }
      })
      return isDuplicate
    },
    validateEmail(email) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(email)
    },
    validateRateInput(event, field, index, trackIndex) {
      this.errors[trackIndex][index].rate = ''
      const rateValue = String(field.rate)
      const keyCode = event.keyCode || event.which
      // Check if the pressed key is the period (.) key
      if (keyCode === 190 || keyCode === 110) {
        event.preventDefault()
      }
      // Remove any non-digit characters from the input
      if (rateValue) this.trackForms[trackIndex][index].rate = parseInt(rateValue.replace(/\D/g, ''), 10) ? parseInt(rateValue.replace(/\D/g, ''), 10) : 0
    },
    stepBack() {
      window.sessionStorage.removeItem('productId')
      this.$router.push({ path: '/client/revenue-share/step-1' })
    },
    showLabel(index) {
      if (index === 0) return true
      return this.isMobileScreen
    },

  },
}
</script>

<style scoped>
@media screen and (min-width: 896px) {
 .c-btn {
  font-size: 1.8rem;
  min-width: 20px;
  padding: 17px 16px;
  margin-top: 25px;
  text-align: center;
  width: 40px;
}
}

@media screen and (max-width: 895px) {
  .c-btn {
  font-size: 1.8rem;
  min-width: 20px;
  padding: 20px 96px;
  text-align: center;
  width: 40px;
}
}

.my-release-search-wrap {
  height: auto;
  display: block;
  background: white;
}

.error-text {
  width: max-content;
  display: block;
}

table {
  width: -webkit-fill-available;
  margin: 10px 0;
  border-collapse: separate;
  border-spacing: 10px;
}

th, td {
  padding: 15px;
}

th {
  text-align: initial;
}

.my-release-search-wrap .form-wrap {
  padding: 0 10px;
}

.form-btn-area-top svg {
  height: 20px;
  width: 13px;
  margin-right: 10px;
  margin-top: 5px;
  color: white;
}

.my-release-search-wrap .form-group .form-item {
  width: 200px;
}

.my-release-search-wrap .form-group .form-label {
  width: 100px;
}

.my-release-search-wrap .row {
  display: flex;
  justify-content: space-between;
}

.form-btn-area-top button {
  color: black;
  font-weight: normal;
}

.form-btn-area-bottom {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 10px;
  flex-wrap: wrap;
}

.form-btn-area-bottom button {
  width: 422px;
  margin-top: 20px;
}

.c-btn-margin {
  margin-top: 0px !important;
}

.form-item {
  position: relative;
}

.form-item p {
  position: absolute;
}

.row {
  margin-bottom: 14px;
}

.form-group {
  padding: 8px 0 !important;
}

.form-wrap {
  margin-top: 0 !important;
  margin-bottom: 12px !important;
}

.pad-left-20 {
  padding-left: 48px;
}

.ml-10 {
  margin-left: 10px !important;
}

td, th {
  padding: 4px 0px !important;
}

.c-btn-mini {
  min-width: 180px;
  padding: 6px 0px 6px 34px;
  background: #e2e2e2 !important;
}

@media screen and (min-width: 896px) {
  .c-btn--delete-large {
    background-size: 21px auto;
    background-position: 55% center;

  }
}

@media screen and (max-width: 895px) {
  .c-btn--delete-large {
    background-position: 50% center;
    background-size: 4vw auto;
  }
  .form-title {
    font-size: 20px;
  }
}
.icon-btn{
  right:148px;
  background: black;
  height: 20px;
  width: 20px
}
</style>
